export default {
    xs: 0,
    sm: 768,
    md: 1024,
    lg: 1400,
    xl: 1920,
};
